<template>
  <div 
    class="detail-container"
    v-if="this.$store.state.detailPage"
  >
    <div class="violation-detail-box columns is-multiline is-centered is-12">
      <div class="column is-9">
        <div class="violation-title has-text-weight-bold">{{ this.$store.state.detailPage.violationType }}</div>
        <div class="violation-number is-size-2">Case Number: <b> {{ this.$store.state.detailPage.violationNumber }} </b></div>
        <div
          class="violation-address has-text-weight-bold"
        >
         L&I District:  {{this.$store.state.searchResults.li_district}}
        </div>
        <div
          class="violation-address has-text-weight-bold"
        >
          OPA Account #:  {{this.$store.state.detailPage[0].opa_account_num}}
        </div>
        <div 
          class="violation-address"
          v-for="item in this.$store.state.detailPage.violationAddress"
          :key="item"
        >
          <div class="multi-cell">
            {{ item }} 
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="violation-date has-text-weight-bold">{{ this.$store.state.detailPage.violationStatus }} </div>
        <div class="bottom-right-link">
          <a
            target="_blank"
            href="https://www.phila.gov/departments/department-of-licenses-and-inspections/resources/applicable-codes/"
          >
            Applicable codes index <i class="fa fa-external-link" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </div>

    <div
      v-if="violationCodeInfo() !== null"
      class="violation-code-info"
    >
      <h1> {{ violationCodeInfo().descCode }} short description 
        <a @click="closeCodeDetail()">CLOSE<i class="fa fa-times fa-lg" aria-hidden="true"></i></a>  
      </h1>
      <p>
        {{ violationCodeInfo().description}}
      </p>
      <p>
      <br>
      <a
        class="code-full-desc"
        onclick=" window.open('http://www.amlegal.com/codes/client/philadelphia_pa/','_blank')"
      >
        View the full code {{ violationCodeInfo().code }}<i class="fa fa-external-link" aria-hidden="true"></i>
      </a>
      </p>
    </div>

    <div class="detail-table-container columns is-multiline is-centered is-12">
      <v-client-table 
        class="table-light no-header column is-12"
        :data="tableData" 
        :columns="columns" 
        :options="options"
      >
        <template
          slot="name"
          slot-scope="{row}"
          class="multi-cell"
        >

        <div
          v-if="row.id == 'Documents*'"
          v-html="row.name"
        >
        </div>
        <!-- single-line cell template -->
        <div v-if="(typeof row.name === 'string') && (row.id !== 'Zoning documents' && row.id !== 'Documents*')">
          <div
            class="multi-cell"
          >
            {{ row.name }}
          </div>
        </div>

        <!-- multi-line cell template -->
        <div 
          v-if="(typeof row.name === 'object') && (row.id !== 'Zoning documents' && row.id !== 'Documents*')"
        >
          <div 
            v-for="item in row.name"
            :key="item"
          >
            <div
              class="multi-cell"
            >
              {{ item }} 
            </div>
          </div>
        </div>

        </template>
      </v-client-table>
    </div>

      <!-- Violations note -->

    <div class="violations-note">*Violation notices on cases that complied prior to June 27, 2024 are not available here.</div>

    <div class="detail-table-container columns is-multiline is-centered is-12"></div>

      <!-- Violations Gray Accordion --> 
      <Accordion 
        :contents="violations"
        class="violations-accordion column is-12"
      >
        <div 
          class="contents-div"
          slot-scope="{ item }"
        >
        <v-client-table 
          class="violation-table table-light no-header"
          :data="violationTableData({item})" 
          :columns="columns" 
          :options="options"
        >
          <template
            slot="name"
            slot-scope="{row}"
            class="multi-cell"
          >

            <!-- single-line cell template -->
            <div v-if="(typeof row.name === 'string') && (row.id !== 'Zoning documents')">
              <div
                class="multi-cell"
              >
                {{ row.name }}
                <a 
                  v-if="row.id === 'code'"
                  @click="codeDetail({item})"
                > 
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </a>
              </div>
            </div>

          </template>
        </v-client-table>
        </div>
      </Accordion>

      <div 
        v-if="investigations.length > 0"
        class="column is-12"
      >
        <v-client-table 
            class="investigations-table table-light"
            :data="investigations"
            :columns="['investigationcompleted', 'casenumber', 'investigationstatus']" 
            :options="investigationOptions"
          > 
            <h1 class="column" slot="beforeTable"> Investigations </h1>
            <template v-for="item in ['investigationcompleted', 'casenumber', 'investigationtype', 'investigationstatus']" :columns="columns" v-slot:[item]="props" >
              <div :key="item.id"> {{ `${props.row[props.column]}` }} </div>
            </template>
        </v-client-table>
      </div>
    </div>
  </div>
</template>

<script>

import Accordion from '@/components/Accordion';
import _ from 'lodash';
import moment from 'moment';
const violationShortDesc  = require('../../../assets/violationdescriptionsandexplanations.json');

export default {
  name: 'ViolationDetail',
  components: {
    Accordion, 
  },
  data() {
    return { 
      columns: ['id', 'name'],
      detailInfo: this.$store.state.detailPage,
      investigationOptions: {
        headings: { investigationcompleted: "Date", casenumber: "Case #", investigationtype: "Description", investigationstatus:  'Status'  }, 
        filterable: false,
        sortable: [],
        pagination: { 
          show: true, 
          virtual: false,
          chunk: 5,
          nav: 'scroll',
          edge: false,
        },
        perPage: 5,
        perPageValues: [],
        cellClasses: {
          investigationstatus: [
            {
              class:'failed',
              condition: row => row.investigationstatus === 'FAILED',
            },
            {
              class:'closed',
              condition: row => row.investigationstatus === 'CLOSED',
            },
            {
              class:'passed',
              condition: row => row.investigationstatus === 'PASSED',
            },
          ],
        },
      },
      options: {
        filterable: false,
        sortable: [],
        highlightMatches: false,
        pagination: { 
          show: false, 
          virtual: false,
        },
        perPage: 100,

        columnsClasses: {
          id: 'violations table-id has-text-weight-bold',
          name: 'table-name',
        },
      },
    }
  },
  mounted() {
    // this.$store.commit('closeCodeDetail');
   },
  destroyed(){
    this.$store.commit('closeCodeDetail');
    this.$store.commit('closeDetail');
  },
  computed: {
    investigations(){
      let investigationArray = _.filter(
        this.$store.state.investigationsResults.msg,
        a => a.casenumber === this.$store.state.detailPage.violationNumber
      )
      investigationArray.map(a => a.investigationcompleted = moment(a.investigationcompleted).format('MMM DD, YYYY'));
      // console.log(investigationArray);
      return investigationArray
    },
    violations(){
      let violationArray = [];
      this.detailInfo.forEach( function(a){
        let violation = new Object();
          violation.code = a.violationcode;
          violation.title = "Violation number: " + a.violationnumber + " - " + a.violationcode;
          violation.type = a.violationcodetitle ? a.violationcodetitle : 'Not Available';
          violation.date = moment(a.violationdate).isValid ? moment(a.violationdate).format('MMM DD, yyyy') : "Not Available";
          violation.status = a.violationstatus;
          violation.descCode = a.violationcode;
          // console.log(a.violationcode, _.filter(violationShortDesc, { "Violation Type": a.violationcode}))
          violation.description = _.filter(violationShortDesc, { "Violation Type": a.violationcode})[0] ?
           _.filter(violationShortDesc, { "Violation Type": a.violationcode})[0]["Violation Explanation"]: "Not Available";
          violation.publicnov = a.publicnov;
          violationArray.push(violation);
        }
      );
      return violationArray
    },
    tableData(){

      let documents;
      if (this.detailInfo.publicnov) {
        documents = `<a href=${this.detailInfo.publicnov} target="_blank" class="violation-link">Notice of Violation Report</a>`;
      } else {
        documents = 'Not Available';
      }

      let tableInfo = [
          // { id: "Owner Name", 
          //   name: this.detailInfo.violationOwner
          // },
          // { id: "Owner mailing address", 
          //   name: this.detailInfo.violationMailingAddress
          // },
          { id: "Case number", 
            name: this.detailInfo.violationNumber
          },
          { id: "Priority", 
            name: this.detailInfo.violationPriority
          },
          { id: "Date added", 
            name: this.detailInfo.violationCreatedDate
          },
          { id: "Date updated", 
            name: this.detailInfo.violationUpdatedDate
          },
          { id: "Resolution date", 
            name: this.detailInfo.violationResolutionDate
          },
          { id: "Documents*",
            name: documents
          },
      ]
      return tableInfo;
    },
  },
  methods: {
    clickBackButton(){
      this.$store.commit('closeDetail');
    },
    codeDetail(value) {
      // console.log("openCodeDetail value: ", value.item);
      this.$store.commit('openCodeDetail', value.item);
      // console.log(this.$store.state);
    },
    closeCodeDetail() {
      this.$store.commit('closeCodeDetail');
    },
    violationCodeInfo(){
      // console.log(this.$store.state.violationCodeInfo)
      return this.$store.state.violationCodeInfo
    },
    violationTableData({item}){
      // console.log(item);
      // item.forEach( a => console.log(a));
      const constItem = item;
      let tableData = [];
      const idList = ['code', 'type', 'date', 'status'];
      idList.forEach( each => {
        // console.log(each);
        let row = new Object();
        row.id = each
        row.name = constItem[each]
        tableData.push(row);
      });
      // console.log("Table data for violation: ", tableData)
      return tableData;
    },
  },
}
</script>
<style lang="scss">
@media screen and (max-width: 768px) {
  .violation-detail-box>div.is-3 {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    div.violation-date, .bottom-right-link {
      text-align: left;
      flex: 100%;
    }
    .bottom-right-link {
      float: right;
    }
  }
}

.columns:last-child {
   margin-bottom: .75rem;
}

div.investigations-table>h1 {
  font-size: 1.125rem;
  font-weight: 600;
}

.table-light {
  h1 {
    padding-left: 0;
  }
  td.failed > div {
  background-color: #FFB6C1 !important;
  padding: 0 5px;
  width: fit-content;
  }
  td.closed > div {
  background-color: #FFFFDD !important;
  padding: 0 5px;
  width: fit-content;
  }
  td.passed > div {
  background-color: #ccffd3 !important;
  padding: 0 5px;
  width: fit-content;
  }
}

.detail-container {
  margin-top: 4rem;
  background-color: white;
  margin: auto;
}

.detail-button {
  margin-top: 20px;
}

.no-header th {
  display: none !important;
}

//  CSS for grey header-box in violation detail page
.detail-container .violation-detail-box {
  background-color: $ben-franklin-blue-light;
  margin: 0;
  padding: 15px 5px 15px 25px;
  position: relative;
  clear: both;
  & .column {
    padding: 0;
  }
  .violation-title {
    text-transform: uppercase;
  }
  .violation-number {
    text-transform: uppercase;
    padding: 5px 0 15px 0;
  }
  .violation-date {
    text-align: right;
    padding-right: 30px;
  }
  .bottom-right-link {
    // right: 15px;
    font-weight: 600;
    font-size: 0.8rem;
    bottom: 10px;
  }

}

.investigations-table {
  thead>tr {
    background-color: white;
    color: black;
    border: none;
    font-weight: 700;
  }
}
.violations-accordion>div.accordion-question {
  padding: 0 15px;
  background: $ghost-grey;
  border-bottom: none;
  border-spacing: 0 14px;
  border-collapse: separate;
} 

.violations-accordion .table-light {
  th, tr, td {
    background: $ghost-grey;
  }
}

.accordion-question {
  margin-bottom: 25px;
}

.violations-accordion .accordion-question .accordion-content .contents-div {
  width: 100%;
}

.violation-table .violations.table-id.has-text-weight-bold {
  text-transform: capitalize;
}

.violation-code-info {
  background: $ghost-grey;
  overflow-y: scroll;
  width: 100%;
  max-width: 750px;
  height: 350px;
  position: fixed;
  margin: auto;
  z-index: 999;
  left: 50%;
  transform: translate(-50%, 0);
  padding: 25px;
  box-shadow: 0 10px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
  h1 {
    font-weight: 600;
    padding-bottom: 20px;
    a {
      float: right;
    }
  }
  p>a {
    margin-top: 15px;
    font-weight: 100;
  }
  .fa-times {
    vertical-align: -0.08em;
  }
  button.code-full-desc {
    border: 2px solid $ben-franklin-blue-dark;
    color: $ben-franklin-blue-dark;
    padding: 12px;
    margin-top: 35px;
    margin-left: auto;
    margin-right: auto;
    display: flow-root;
    cursor: pointer;
    i {
      margin-left: 10px;
    }
  }
}

// End Violations Detail CSS

.table-id.has-text-weight-bold {
  width: 35%;
}

div.is-pulled-right.VueTables__limit {
   display: none;
}

// CSS for the Zoning Cell elements from scoped-slot
.zoning-border {
  &:not(:last-child){
    border-bottom: 1px black solid;
    padding-bottom: 10px;
  }
  width: 100%;
  height: 100%;
  clear: both;
  margin: 5px 0;
  display: flow-root;
  position: relative;
  .zoning-left {
    width: 50%;
    float: left;
    display: block;
  }
  .zoning-right {
    position: absolute;
    padding: 10px;
    right: 0;
  }
  .zoning-bottom {
    font-size: small;
    display: flex;
    .zoning-small {
      display: inline-grid;
      flex-grow: 1;
    }
  }
  }

  .violations-note {
    padding-left: 16px !important;
  }

  .violation-link {
    font-weight: 600;
    text-decoration: underline;
  }

  

</style>